import React, { PureComponent } from 'react'
import {
    // TextField,
    Divider,
    Typography,
    // FormControlLabel,
    // Checkbox,
    Button,
} from '@material-ui/core'
import {
    tenureMenuItems,
    affordabilityThresholdMenuItems,
    afforabilityTermMenuItems,
} from 'shared/helpers';
import { FlatButton } from 'shared/mui-styles';
import SwitchInFilter from 'bundles/Dashboard/components/SwitchInFilter';
// import { Help } from '@material-ui/icons';
import Dropdown from 'shared/components/Dropdown';

const classes = {
    fullWidth: {
        width: '100%',
    },
    halfWidth: {
        width: '35%'
    },
    divider: {
        margin: '15px 0',
    },
    h7: {
        fontSize: '1.10rem',
        fontWeight: '400',
    },
}

class PipelineFilter extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            switches: {
    
                

            }
        }
    }

    render() {

        const { 
           
            tenure,
            affordabilityThreshold,
            afforabilityTerm,
            construction,
            permanentSupportativeHousing,
            communityLandTrust,
            greenCertified,
            innovation,
            nonprofit,
            bIPOC,
            families,
            seniors,
            formerlyHomeless,
            handleFilterChangePipeline,
            onSubmitPipeline,
            onResetPipeline
        } = this.props;



        const switchData = [
            [
                {
                    stateVariable: construction,
                    value: 'construction',
                    label: 'New Construction',
                    tooltip: 'TBD'
                }
            ],
            [
                {
                    stateVariable: permanentSupportativeHousing,
                    value: 'permanentSupportativeHousing',
                    label: 'Permanent Supportative Housing (PSH) ',
                    tooltip: 'TBD'
                },
                {
                    stateVariable: communityLandTrust,
                    value: 'communityLandTrust',
                    label: 'Community Land Trust',
                    tooltip: 'TBD'
                },
                {
                    stateVariable: greenCertified,
                    value: 'greenCertified',
                    label: 'Green Certified',
                    tooltip: 'TBD'
                },
                {
                    stateVariable: innovation,
                    value: 'innovation',
                    label: 'Innovation',
                    tooltip: 'ADUs, Tiny Homes, Modular, Co-Living  '
                },

            ],
            [
                {
                    stateVariable: nonprofit,
                    value: 'nonprofit',
                    label: 'Nonprofit',
                    tooltip: 'Nonprofit Developers Financed/Funded'
                },
                {
                    stateVariable: bIPOC,
                    value: 'bIPOC',
                    label: 'BIPOC',
                    tooltip: 'BIPOC Developers Financed/Funded '
                }
            ],
            [
                {
                    stateVariable: families,
                    value: 'families',
                    label: 'Families',
                    tooltip: 'TBD'
                },
                {
                    stateVariable: seniors,
                    value: 'seniors',
                    label: 'Seniors',
                    tooltip: 'TBD'
                },
                {
                    stateVariable: formerlyHomeless,
                    value: 'formerlyHomeless',
                    label: 'Formerly Homeless',
                    tooltip: 'TBD'
                }
            ]
        ];

        const dropdownData = [
            {
                value: tenure,
                name: 'tenure',
                menuItems: tenureMenuItems,
            },
            {
                value: affordabilityThreshold,
                name: 'affordabilityThreshold',
                menuItems: affordabilityThresholdMenuItems,
            },
            {
                value: afforabilityTerm,
                name: 'afforabilityTerm',
                menuItems: afforabilityTermMenuItems,
            }
        ]

        return (
            <div className="filter-container">
                <div className="content">
                    <div className="container-fluid card-with-padding">
                        <SwitchInFilter
                            data={switchData[0]}
                            handleFilterChangePipeline={(e) => { handleFilterChangePipeline(e) }}
                        />
                        <div className="row row-spacing">
                            <div className="col">
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                    <Typography variant="h6" style={classes.h7}>
                                    Tenure
                                    </Typography>
                                    {/* <CustomTooltip
                                        title="TBD"
                                        placement="right"
                                    >
                                        <Help fontSize="small" style={{ marginLeft: 7,color: 'rgb(115, 173, 150)' }}  />
                                    </CustomTooltip> */}
                                </div>
                                <Dropdown
                                    data={dropdownData[0]}
                                    handleChange={handleFilterChangePipeline}
                                />
                            </div>
                        </div>
                        <Divider style={classes.divider} />
                        <div className="row row-spacing">
                            <div className="col">
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                    <Typography variant="h6" style={classes.h7}>
                                    Affordability Threshold (by AMI)
                                    </Typography>
                                    {/* <CustomTooltip
                                        title="TBD"
                                        placement="right"
                                    >
                                        <Help fontSize="small" style={{ marginLeft: 7,color: 'rgb(115, 173, 150)' }}  />
                                    </CustomTooltip> */}
                                </div>
                                <Dropdown
                                    data={dropdownData[1]}
                                    handleChange={handleFilterChangePipeline}
                                />
                            </div>
                        </div>
                        <div className="row row-spacing">
                            <div className="col">
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                    <Typography variant="h6" style={classes.h7}>
                                    Afforability Term
                                    </Typography>
                                    {/* <CustomTooltip
                                        title="TBD"
                                        placement="right"
                                    >
                                        <Help fontSize="small" style={{ marginLeft: 7,color: 'rgb(115, 173, 150)' }}  />
                                    </CustomTooltip> */}
                                </div>
                                <Dropdown
                                    data={dropdownData[2]}
                                    handleChange={handleFilterChangePipeline}
                                />
                            </div>
                        </div>
                        <Divider style={classes.divider} />
                        <SwitchInFilter
                            data={switchData[1]}
                            handleFilterChangePipeline={(e) => { handleFilterChangePipeline(e) }}
                        />
                        <Divider style={classes.divider} />
                        <SwitchInFilter        
                            data={switchData[2]}
                            handleFilterChangePipeline={(e) => { handleFilterChangePipeline(e) }}
                        />
                        <Divider style={classes.divider} />
                        <SwitchInFilter
                            data={switchData[3]}
                            handleFilterChangePipeline={(e) => { handleFilterChangePipeline(e) }}
                        />
                    </div>
                    <div className="bottom-bar">
                        <FlatButton
                            variant="contained"
                            style={{ width: '100%',backgroundColor: 'rgba(115,173,150,255)',color:'white'}}
           
                            onClick={onSubmitPipeline}
                        >
                            {/* {`Update ${mapOrTable ? 'Table' : 'Map'}`} */}
                            APPLY FILTERS
                        </FlatButton>
                        <Button
                            variant="outlined"
                            style={{ width: '100%', marginTop: 10 }}
                            onClick={onResetPipeline}
                        >
                            Clear Filters
                        </Button>
                    </div>
                </div>
            </div>
        )
    }
}

export default PipelineFilter